module.exports = __webpack_public_path__ + "img/closed.3b691110.webp";